import React, { useState, useEffect, useRef, useContext } from "react";
import './Themes.scss';
import { Breadcrumb } from 'react-bootstrap';
import BootstrapTable from "react-bootstrap-table-next";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import useOutsideClick from "hooks/useOutsideClick";
import paginationFactory from 'react-bootstrap-table2-paginator';
import Axios from "utility/Axios";
import AddThemeModal from '../components/AddThemeModal';
import EditSubthemeModel from '../components/EditSubthemeModel';
import configURL from 'config/config';
import AppContext from 'store/AppContext';
import EziLoader from "components/EziLoader";
import { toast } from "react-toastify";
import { confirmAlert } from 'react-confirm-alert';

const Subthemes = props => {
    const { languageObj = {} } = useContext(AppContext)
    const [themeModal, setThemeModal] = useState(false);
    const [editModalVisible, setEditModalVisible] = useState(false);
    const [editModelData, setEditModelData] = useState({});
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const ref = useRef();
    const hookLocation = useLocation();
    let urlParams = useParams();
    const [dropdownFlag, setDropdownFlag] = useState(false);
    const [theme, setTheme] = useState({
        id: urlParams.theme_id,
        name: hookLocation.state.name,
        description: hookLocation.state.description
    });
    const [themes, setThemes] = useState([]);
    const [pagination, setPagination] = useState({ current_page: 0, total: 0, per_page: 10 });
    const [subThemes, setSubthemes] = useState([]);
    const navigate = useNavigate();

    const dropdown = () => {
        setDropdownFlag(!dropdownFlag);
    }

    const statusFormatter = (cell, row) => {
        return (
            <span className={`themes-status_c ${row.status === "active" ? "active" : "offline"}`}>{cell}</span>
        );
    }

    const subThemeNameFormatter = (cell, row) => {
        return (
            <span className="theme-name_c">{cell}</span>
        );
    }

    const AddNewFormatter = (column, colIndex) => {
        return (
            <div className="add-theme-btn-wrap">
                <button type="button" className={`btn-ripple ezi-pink-btn add-theme-btn `} onClick={() => {
                    setThemeModal(true)
                }}>{column.text} <span className="add_ic"></span></button>
            </div>
        );
    }

    const actionFormatter = (cell, row) => {
        return (
            <div className="theme-editDelete-wrap">
                <button type="button" className={`theme-edit`} onClick={() => {
                    setEditRowData(row)

                }}>Edit</button>
                <button type="button" className={`theme-delete`} onClick={() => {
                    deleteEntry(row.id)

                }}>Delete</button>
            </div>
        );
    }

    const columns = [
        { dataField: "name", text: "sub themes", formatter: subThemeNameFormatter },
        { dataField: "description", text: "Description" },
        { dataField: "status", text: "Status", formatter: statusFormatter },
        { dataField: 'theme', text: 'Add new sub-theme', headerFormatter: AddNewFormatter, formatter: actionFormatter },
    ];

    const changeTheme = (themeObj) => {
        setDropdownFlag(!dropdownFlag);
        setTheme(themeObj);
        setSubthemeListing(themeObj);
    }

    const setSubthemeListing = (themeObj, pageno = 1) => {
        setLoading(true);
        setEditModalVisible(false);
        let formData = new FormData();
        formData.append("theme_id", themeObj.id);
        formData.append("page", pageno);
        formData.append("category_id", urlParams.category_id);
        formData.append("type", hookLocation.state.type || 'survey');
        Axios.post(configURL.partner_subthemeListing, formData).then(res => {
            setLoading(false);
            if (res.data.success === true) {
                setPagination(res.data.pagination);
                setSubthemes(res.data.result);
            } else {
                toast.warn(res.data.message || 'Something went wrong.')
            }
        }).catch(err => {
            console.log(err);
            toast.warn('Something went wrong.')
        })
    };

    const toggleEditThemeModal = () => {
        setEditModalVisible(!editModalVisible);
    }

    const setEditRowData = (rowData) => {
        toggleEditThemeModal();
        setEditModelData(rowData);
    }

    const searchCategory = (e) => {
        setSearchTerm(e.target.value);
    }

    useOutsideClick(ref, () => {
        dropdownFlag && setDropdownFlag(false);
    });

    const RemotePagination = ({ data, page = 1, sizePerPage, onTableChange, totalSize }) => (
        <BootstrapTable
            remote
            keyField="id"
            data={subThemes}
            columns={columns}
            noDataIndication="Table is Empty"
            pagination={paginationFactory({ page, sizePerPage, totalSize, hideSizePerPage: true, })}
            onTableChange={onTableChange}
            rowClasses="theme-datatable-row"
        />
    );

    const handleAllEntriesChange = (type, { page, sizePerPage }) => {
        if (type === 'pagination') {
            setSubthemeListing(theme, page);
        }
    }


    const deleteEntry = (rowId) => {
        confirmAlert({
            title: 'Delete Sub-Theme',
            message: `Are you sure ? Once you delete the Sub-theme, corresponding Sub-theme will be deleted from template as well`,
            buttons: [
                {
                    label: 'Okay',
                    onClick: () => {
                        if (rowId !== null) {
                            let formData = new FormData();
                            formData.append("id", rowId);
                            formData.append("model", 'se_sub_themes');
                            Axios.post(configURL.partner_deleteRow, formData).then(resposnse => {
                                if (resposnse !== undefined && resposnse.status) {
                                    setSubthemeListing(theme);
                                } else {
                                    toast.warn(resposnse.data.message || "Something went wrong!")
                                }
                            })
                        }
                    }
                },
                { label: 'Cancel' }
            ]
        });
    }

    useEffect(() => {
        let formData = new FormData();
        formData.append("theme_id", theme.id);
        formData.append("category_id", urlParams.category_id);
        formData.append("type", hookLocation.state.type || 'survey');
        Axios.post(configURL.partner_subthemeListing, formData).then(res => {
            if (res.data.success === true) {
                setPagination(res.data.pagination);
                setSubthemes(res.data.result);
            } else {
                toast.warn(res.data.message || 'Something went wrong.')
            }
        }).catch(err => {
            console.log(err);
            toast.warn('Something went wrong.')
        })
        let themeData = new FormData();
        themeData.append("category_id", urlParams.category_id);
        themeData.append("type", hookLocation.state.type || 'survey');
        Axios.post(configURL.partner_themeListing, themeData).then(res => {
            if (res.data.success === true) {
                setThemes(res.data.result);
            } else {
                toast.warn(res.data.message || 'Something went wrong.')
            }
        }).catch(err => {
            console.log(err);
            toast.warn('Something went wrong.')
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const results = themes.filter(ele =>
            ele.name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setSearchResults(results);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchTerm]);

    let themeList = (searchTerm !== '') ? searchResults : themes;

    return (
        <React.Fragment>
            <section className="Page-Themes" >
                <div className="breadcrumb_ezi">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => navigate(-1)}> Theme </Breadcrumb.Item>
                        <Breadcrumb.Item onClick={() => navigate(-1)}> {hookLocation.state.type || 'survey'} </Breadcrumb.Item>
                        <Breadcrumb.Item onClick={() => navigate(-1)}> {hookLocation.state.category}</Breadcrumb.Item>
                        <Breadcrumb.Item> {theme.name || ''} </Breadcrumb.Item>
                    </Breadcrumb>
                    <div className="themes-dropdown" >
                        <button type="button" onClick={dropdown} className={`themes-dropdown-btn selected`}> {(theme.name !== undefined && theme.name !== '') ? theme.name : 'Select Theme'} </button>
                        <div className={`themes-inner-dropdown ${dropdownFlag ? 'active' : ""}`} ref={ref}>
                            <div className="themes-dropdown-header">
                                <input type="text" className="themes-dropdown-search" value={searchTerm} onChange={(e) => searchCategory(e)} placeholder={languageObj.translate('Search.1')} />
                                <label>Themes</label>
                            </div>
                            <ul>
                                {
                                    themeList.map(themedata =>
                                        <li onClick={() => changeTheme(themedata)} key={themedata.id}>
                                            {themedata.name}
                                        </li>
                                    )
                                }
                            </ul>
                        </div>
                    </div>
                    <span className="themes-subtitle"> {theme.description || ''} </span>
                </div>
                <AddThemeModal commonid={theme.id} name="sub-theme" fieldname="Sub Theme" commonidname="theme_id" show={themeModal} onHide={() => setThemeModal(false)} updatethemelisting={() => setSubthemeListing(theme)} />
                <EditSubthemeModel show={editModalVisible} onHide={() => toggleEditThemeModal()} toggleeditmodal={() => toggleEditThemeModal()} name="Sub Theme" editdata={editModelData} updatethemelisting={() => setSubthemeListing(theme)} />
                <div className="themes-content">
                    <RemotePagination
                        data={subThemes}
                        page={pagination?.current_page || 0}
                        sizePerPage={pagination?.per_page || 10}
                        totalSize={pagination?.total || 0}
                        onTableChange={handleAllEntriesChange}
                    />
                </div>
            </section>
            {loading && <EziLoader />}
        </React.Fragment>
    )
}

export default Subthemes;